import type { FaireProductEntity } from "../../entity_types/product";

export const p_9vat6t9w2p: FaireProductEntity = {
  token: "p_9vat6t9w2p",
  type: "product",
  name: "Old Fashioned TY Flat Note Set",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/67be6fb2a87f91033e2b0452e4cc78b8d308489a738ae03b70ad125a7fada647.webp",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/020dd35153cde7f323b6e8b304cb1c1ff2ad8269ec9c15725339455fda0c1424.jpeg",
    "https://cdn.faire.com/fastly/4ecb6c9f43b3d1724015ea4444ef7d301e83bd29ff22ef7766d9eb27a1d67498.jpeg",
  ],
  priceDollars: 8,
  description:
    'A flat note is concise and smart. Not ostentatious, but clever. And without too much room, you can get right to the point, or be "well-edited" as we like to say.\n\nThis set includes 8 envelopes and 8 beautifully illustrated notecards, each with an extra illustration on the back.',
  tags: [],
  msrpDollars: 16,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:36:15.348Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
